import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Place,
  SolarPower,
} from '@mui/icons-material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
  Link,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import hero1 from '../../Image/hero1.svg';
import Logo from '../Logo';
import { fadeAnimateVariants, slideAnimateVariants } from '../animate/animate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import HelpIcon from '@mui/icons-material/Help';
import MenuIcon from '@mui/icons-material/Menu';
import { getOfferCount, addReferral } from '../../services/CustomerService';
import SolarQuoteForm from './SolarQuoteForm';

const TopSec = ({ startLink, researchLink, openForm }) => {
  const [searchParams] = useSearchParams();
  const fName = searchParams.get('fName');
  console.log('referral', fName);
  const [referalName, setReferalName] = useState(null);
  useEffect(() => {
    if (fName && openForm) {
      setReferalName(fName);
    }
  }, [fName]);
  const [anchorEl, setAnchorEl] = useState(null); // For Menu anchor
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Open menu
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close menu
  };
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [pincode, setPincode] = React.useState('');
  const [plantSize, setPlantSize] = React.useState('');
  const [pincodeError, setPincodeError] = useState('');
  const [isPincodeValid, setIsPincodeValid] = React.useState(false);
  const [openQuote, setOpenQuote] = useState(false);
  const [errors, setErrors] = React.useState({
    pincode: '',
    plantSize: '',
  });

  const [blogMenuAnchor, setBlogMenuAnchor] = useState(null);
  const isBlogMenuOpen = Boolean(blogMenuAnchor);

  const handleBlogMenuClose = () => {
    setBlogMenuAnchor(null);
  };

  const [learnSolarAnchor, setLearnSolarAnchor] = useState(null);
  const isLearnSolarOpen = Boolean(learnSolarAnchor);

  const handleLearnSolarClick = (event) => {
    setLearnSolarAnchor(event.currentTarget);
  };

  const handleLearnSolarClose = () => {
    setLearnSolarAnchor(null);
  };

  useEffect(() => {
    if (openForm) {
      setOpenQuote(true);
    }
  }, [openForm]);

  const validatePincode = async (pincode) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`,
      );
      const data = await response.json();

      if (data[0].Status === 'Success' && data[0].PostOffice?.length > 0) {
        const postOffice = data[0].PostOffice[0];
        return {
          isValid: true,
          error: '',
          district: postOffice.District,
          state: postOffice.State,
        };
      } else {
        return {
          isValid: false,
          error: 'Invalid pincode',
          district: '',
          state: '',
        };
      }
    } catch (error) {
      return {
        isValid: false,
        error: 'Error validating pincode',
        district: '',
        state: '',
      };
    }
  };

  const validateForm = async () => {
    let isValid = true;
    const newErrors = { pincode: '', plantSize: '' };
    let locationData = { district: '', state: '' };

    if (!pincode) {
      newErrors.pincode = 'PinCode is required';
      isValid = false;
    } else if (pincode.length < 6) {
      newErrors.pincode = 'PinCode must be 6 digits';
      isValid = false;
    } else {
      // Only validate pincode with API if length is correct
      const validation = await validatePincode(pincode);
      if (!validation.isValid) {
        newErrors.pincode = validation.error;
        isValid = false;
      } else {
        locationData = {
          district: validation.district,
          state: validation.state,
        };
      }
    }

    if (!plantSize) {
      newErrors.plantSize = 'Plant size is required';
      isValid = false;
    } else if (plantSize < 1 || plantSize > 99) {
      newErrors.plantSize = 'Plant size must be between 1 and 99 kW';
      isValid = false;
    }

    setErrors(newErrors);
    return { isValid, locationData };
  };

  const validatePincodeForPlantSize = async (pincode) => {
    const validation = await validatePincode(pincode);
    if (!validation.isValid) {
      setPincodeError(validation.error);
      setIsPincodeValid(false);
    } else {
      setPincodeError('');
      setIsPincodeValid(true);
    }
  };

  React.useEffect(() => {
    if (pincode.length === 6) {
      validatePincodeForPlantSize(pincode);
    } else {
      setIsPincodeValid(false);
    }
  }, [pincode]);

  const plantSizeError =
    plantSize < 1 || plantSize > 99
      ? 'Plant size must be between 1 and 99 kW'
      : '';
  const getOffer = async (plantSize, pincode) => {
    // const res = await getOfferCount(plantSize, pincode);
    // return res;
    // console.log("res",res);
  };

  const handleSubmit = async () => {
    const { isValid, locationData } = await validateForm();
    if (isValid) {
      navigate(
        `/open-offers?pincode=${pincode}&plantSize=${plantSize}&district=${encodeURIComponent(locationData.district)}&state=${encodeURIComponent(locationData.state)}`,
      );
    }
  };
  const slideInVariants = {
    hidden: { x: '-50%', opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: 'easeOut' },
    },
  };

  const handleGetQuote = () => {
    navigate('/getquote');
  };

  return (
    <Stack
      sx={{
        minHeight: '90vh',
      }}
    >
      <Stack
        display={'flex'}
        justifyContent={'space-between'}
        flexDirection={'row'}
      >
        <Stack direction='row' alignItems='center'>
          <Logo height={'80px'} width={'156px'} />
        </Stack>

        <Stack spacing='15px' direction='row' padding={'10px 0px'} gap={'10px'}>
          <Stack
            display={isMobile ? 'none' : 'flex'}
            direction={'row'}
            gap={'10px'}
          >
            <Button
              onClick={handleLearnSolarClick}
              size='small'
              component={motion.button}
              variants={slideAnimateVariants}
              initial='initial'
              whileInView='animate'
              custom={2.5}
              viewport={{
                once: true,
              }}
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '50px',
                padding: '0px 20px',
              }}
              endIcon={
                isLearnSolarOpen ? (
                  <ExpandLessIcon fontSize='large' />
                ) : (
                  <ExpandMoreIcon fontSize='large' />
                )
              }
            >
              Learn solar
            </Button>
            <Menu
              anchorEl={learnSolarAnchor}
              open={isLearnSolarOpen}
              onClose={handleLearnSolarClose}
              sx={{ mt: 1 }}
            >
              <MenuItem
                onClick={() => {
                  window.location.href =
                    'https://www.vaysolar.com/docs/solar-buying-guide';
                  handleLearnSolarClose();
                }}
              >
                Solar buying guide
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.location.href =
                    'https://www.vaysolar.com/docs/how-solar-works';
                  handleLearnSolarClose();
                }}
              >
                How solar works?
              </MenuItem>
            </Menu>
            <Button
              onClick={() => {
                window.location.href = 'https://www.vaysolar.com/docs/blog/';
              }}
              size='small'
              variant='text'
              component={motion.button}
              variants={slideAnimateVariants}
              initial='initial'
              whileInView='animate'
              custom={2.5}
              viewport={{
                once: true,
              }}
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '50px',
                padding: '0px 20px',
              }}
            >
              Blog
            </Button>
            <Button
              // variant='outlined'
              size='small'
              component={motion.button}
              variants={slideAnimateVariants}
              initial='initial'
              whileInView='animate'
              viewport={{
                once: true,
              }}
              disableElevation
              onClick={() => {
                window.open('https://www.vaysolar.com/en/getquote', '_blank');
              }}
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'none',
                borderRadius: '50px',
                padding: '0px 20px',
              }}
            >
              Book Expert call
            </Button>
          </Stack>

          <Button
            size='small'
            variant='filled'
            component={motion.button}
            variants={slideAnimateVariants}
            initial='initial'
            whileInView='animate'
            onClick={() => navigate('/login')}
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '50px',
              padding: '0px 20px',
              marginLeft: '0px',
              color: 'green',
              backgroundColor: theme.palette.primary.lighter,
            }}
          >
            Sign In
          </Button>

          <Box
            style={{ marginLeft: '0px' }}
            sx={{ display: isMobile ? 'flex' : 'none' }}
          >
            <IconButton
              onClick={handleMenuOpen}
              sx={{
                color: 'black',
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem
                onClick={() => {
                  window.location.href =
                    'https://www.vaysolar.com/docs/solar-buying-guide';
                  handleLearnSolarClose();
                }}
              >
                Solar buying guide
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.location.href =
                    'https://www.vaysolar.com/docs/how-solar-works';
                  handleLearnSolarClose();
                }}
              >
                How solar works?
              </MenuItem>
              <MenuItem
                onClick={() => {
                  window.location.href = 'https://www.vaysolar.com/docs/blog/';
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  window.open('https://forms.gle/FYBfYapmfg77pZkz9', '_blank');
                }}
              >
                Book Expert Call
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  if (researchLink) {
                    navigate(researchLink);
                  } else {
                    window.location.href =
                      'https://www.vaysolar.com/docs/?utm_source=landing-page&utm_medium=landing-page&utm_campaign=landing-page';
                  }
                }}
              >
                Learn rooftop solar
              </MenuItem>
            </Menu>

            {!isMobile && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  onClick={() => {
                    if (researchLink) {
                      navigate(researchLink);
                    } else {
                      window.location.href =
                        'https://www.vaysolar.com/docs/?utm_source=landing-page&utm_medium=landing-page&utm_campaign=landing-page';
                    }
                  }}
                  size='small'
                  variant='text'
                  component={motion.button}
                  variants={slideAnimateVariants}
                  initial='initial'
                  animate='animate'
                  sx={{
                    borderRadius: '50px',
                    padding: '0px 20px',
                  }}
                >
                  Learn rooftop solar
                </Button>
                <Button
                  variant='outlined'
                  size='small'
                  component={motion.button}
                  variants={slideAnimateVariants}
                  initial='initial'
                  animate='animate'
                  disableElevation
                  onClick={() => {
                    window.open(
                      'https://forms.gle/FYBfYapmfg77pZkz9',
                      '_blank',
                    );
                  }}
                  sx={{
                    borderRadius: '50px',
                    padding: '0px 20px',
                  }}
                >
                  Book Expert Call
                </Button>
              </div>
            )}
          </Box>
        </Stack>
      </Stack>
      <Grid
        pt={{ sm: '32px', xs: '10px' }}
        pb={isMobile ? '2px' : '32px'}
        container
        spacing={'28px'}
      >
        <Grid
          container
          item
          xs={12}
          direction={'row-reverse'}
          sx={{
            spacing: { sm: '10px', xs: '40px' },
          }}
          pb={'76px'}
        >
          {openQuote ? (
            <motion.div
              initial='hidden'
              animate='visible'
              exit='hidden'
              variants={slideInVariants}
            >
              {isMobile ? (
                <Grid mb='2rem' item xs={12}>
                  {referalName ? (
                    <Typography
                      custom={0.5}
                      variant='h1'
                      variants={fadeAnimateVariants}
                      initial='initial'
                      whileInView='animate'
                      viewport={{
                        once: true,
                      }}
                      mb={isMobile ? 'none' : '4rem'}
                      component={motion.h2}
                      sx={{ fontWeight: '900' }}
                      // fontWeight={theme.typography.h4.fontWeight}
                      fontSize={{
                        md: '48px',
                        sm: '40px',
                        xs: '34px',
                      }}
                    >
                      Join{' '}
                      <Box
                        component='span'
                        sx={{
                          color: 'primary.main',
                        }}
                      >
                        {referalName}’s
                      </Box>{' '}
                      green energy network
                      <Typography fontWeight={'bold'} mt={'8px'}>
                        Find. Select. Finance. Install. Maintain.
                      </Typography>
                    </Typography>
                  ) : (
                    <Typography
                      custom={0.5}
                      variant='h1'
                      variants={fadeAnimateVariants}
                      initial='initial'
                      whileInView='animate'
                      viewport={{
                        once: true,
                      }}
                      mb={isMobile ? 'none' : '4rem'}
                      component={motion.h2}
                      sx={{ fontWeight: '900' }}
                      // fontWeight={theme.typography.h4.fontWeight}
                      fontSize={{
                        md: '48px',
                        sm: '40px',
                        xs: '34px',
                      }}
                    >
                      Easiest way to go{' '}
                      <Box
                        component='span'
                        sx={{
                          color: 'primary.main',
                        }}
                      >
                        solar
                      </Box>{' '}
                      <Typography fontWeight={'bold'} mt={'8px'}>
                        Find. Select. Finance. Install. Maintain.
                      </Typography>
                    </Typography>
                  )}
                </Grid>
              ) : (
                <></>
              )}
              <SolarQuoteForm />
            </motion.div>
          ) : (
            <Grid
              display={isMobile ? 'none' : 'flex'}
              item
              sm={5}
              xs={12}
              sx={{
                position: 'relative',
                pt: { xs: '0px', sm: '193px' },
              }}
            >
              <Box
                className='center green pulse'
                variants={fadeAnimateVariants}
                initial='initial'
                custom={2.5}
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                mt={'3rem'}
                component={motion.div}
                sx={{
                  width: isMobile ? '62px' : '96px',
                  height: isMobile ? '62px' : '96px',
                  borderRadius: '50%',
                  boxShadow: '0px 0px 1px 1px #FBD300',
                  backgroundColor: '#FBD300',
                  animation: 'pulse-animation 2s infinite',
                  position: 'absolute',
                  left: '10px',
                  top: 0,
                  zIndex: 1,
                  '@keyframes pulse-animation': {
                    '0%': {
                      boxShadow: '0 0 0 0px #FBD300',
                    },
                    '100%': {
                      boxShadow: '0 0 0 12px rgba(0, 0, 0, 0)',
                    },
                  },
                }}
              >
                {/* Your component content */}
              </Box>
              <Box
                component={motion.img}
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                sx={{
                  transform: { sm: 'scaleX(1)', xs: 'scaleX(-1)' },
                }}
                custom={1.5}
                viewport={{
                  once: true,
                }}
                width='100%'
                // maxWidth={{
                //   md: 380,
                //   sm: 350,
                //   xs: 350,
                // }}
                height='100%'
                src={hero1}
                alt=''
              />
            </Grid>
          )}
          <Grid item sm={7} xs={12} alignSelf={'flex-end'}>
            {isMobile ? (
              <>
                <Typography
                  custom={0.5}
                  variant='h1'
                  variants={fadeAnimateVariants}
                  initial='initial'
                  whileInView='animate'
                  viewport={{
                    once: true,
                  }}
                  mb={isMobile ? 'none' : '5px'}
                  component={motion.h2}
                  sx={{
                    fontFamily: 'Plus Jakarta Sans',
                    fontWeight: 700,
                    letterSpacing: '-0.5px',
                    WebkitTextStroke: isMobile ? '0.6px black' : '1.2px black',
                    color: '#000',
                  }}
                  // fontWeight={theme.typography.h4.fontWeight}
                  fontSize={{
                    md: '48px',
                    sm: '40px',
                    xs: '34px',
                  }}
                >
                  Rooftop solar{' '}
                  <Box
                    component='span'
                    sx={{
                      fontFamily: 'Plus Jakarta Sans',
                      fontWeight: 700,
                      letterSpacing: '-0.5px',
                      WebkitTextStroke: isMobile
                        ? '0.6px #216b38'
                        : '1.2px #216b38',
                      color: 'primary.main',
                    }}
                  >
                    made simple{' '}
                  </Box>{' '}
                </Typography>
              </>
            ) : (
              <Grid item xs={12}>
                {referalName ? (
                  <Typography
                    custom={0.5}
                    variant='h1'
                    variants={fadeAnimateVariants}
                    initial='initial'
                    whileInView='animate'
                    viewport={{
                      once: true,
                    }}
                    mb={isMobile ? 'none' : '4rem'}
                    component={motion.h2}
                    sx={{ fontWeight: '900' }}
                    // fontWeight={theme.typography.h4.fontWeight}
                    fontSize={{
                      md: '48px',
                      sm: '40px',
                      xs: '34px',
                    }}
                  >
                    Join{' '}
                    <Box
                      component='span'
                      sx={{
                        color: 'primary.main',
                      }}
                    >
                      {referalName}’s
                    </Box>{' '}
                    green energy network
                    <Typography fontWeight={'bold'} mt={'8px'}>
                      Find. Select. Finance. Install. Maintain.
                    </Typography>
                  </Typography>
                ) : (
                  <>
                    <Typography
                      custom={0.5}
                      variant='h1'
                      variants={fadeAnimateVariants}
                      initial='initial'
                      whileInView='animate'
                      viewport={{
                        once: true,
                      }}
                      mb={isMobile ? 'none' : '5px'}
                      component={motion.h2}
                      sx={{
                        fontFamily: 'Plus Jakarta Sans',
                        fontWeight: 700,
                        letterSpacing: '-0.5px',
                        WebkitTextStroke: isMobile
                          ? '0.6px black'
                          : '1.2px black',
                        color: '#000',
                      }}
                      // fontWeight={theme.typography.h4.fontWeight}
                      fontSize={{
                        md: '48px',
                        sm: '40px',
                        xs: '34px',
                      }}
                    >
                      Rooftop solar system {' '}
                      <Box
                        component='span'
                        sx={{
                          fontFamily: 'Plus Jakarta Sans',
                          fontWeight: 700,
                          letterSpacing: '-0.5px',
                          WebkitTextStroke: isMobile
                            ? '0.6px #216b38'
                            : '1.2px #216b38',
                          color: 'primary.main',
                        }}
                      >
                        made simple{' '}
                      </Box>{' '}
                    </Typography>
                    <Typography
                      fontWeight={'600'}
                      mb={isMobile ? 'none' : '2rem'}
                    >
                      Find. Select. Finance. Install. Maintain.
                    </Typography>
                  </>
                )}
              </Grid>
            )}

            <Grid
              display={isMobile ? 'flex' : 'none'}
              item
              sm={5}
              xs={12}
              sx={{
                position: 'relative',
                pt: { xs: '0px', sm: '25px' },
              }}
            >
              <Box
                className='center green pulse'
                variants={fadeAnimateVariants}
                initial='initial'
                custom={2.5}
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                mt={'3rem'}
                component={motion.div}
                sx={{
                  width: isMobile ? '62px' : '96px',
                  height: isMobile ? '62px' : '96px',
                  borderRadius: '50%',
                  boxShadow: '0px 0px 1px 1px #FBD300',
                  backgroundColor: '#FBD300',
                  animation: 'pulse-animation 2s infinite',
                  position: 'absolute',
                  left: isMobile ? '220px' : '200px',
                  top: isMobile ? '-51px' : '0px',
                  zIndex: 1,
                  '@keyframes pulse-animation': {
                    '0%': {
                      boxShadow: '0 0 0 0px #FBD300',
                    },
                    '100%': {
                      boxShadow: '0 0 0 12px rgba(0, 0, 0, 0)',
                    },
                  },
                }}
              >
                {/* Your component content */}
              </Box>
              <Box
                component={motion.img}
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                sx={{
                  transform: { sm: 'scaleX(1)', xs: 'scaleX(-1)' },
                }}
                custom={2.5}
                viewport={{
                  once: true,
                }}
                width='100%'
                maxWidth={{
                  md: 380,
                  sm: 350,
                  xs: 350,
                }}
                height='100%'
                src={hero1}
                alt=''
              />
            </Grid>
            <Stack mb={isMobile ? 'none' : '3rem'} spacing={1}>
              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                color={'text.secondary'}
                mb={isMobile ? 'none' : '3rem'}
                component={motion.h5}
                sx={{ fontWeight: '600' }}
                // fontWeight={theme.typography.h4.fontWeight}
                fontSize={{
                  md: '23px',
                  sm: '15px',
                  xs: '15px',
                }}
              >
                Subsidy and non-subsidy solar plans
              </Typography>
              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                component={motion.h5}
                sx={{ fontWeight: '600' }}
                fontSize={{
                  md: '20px',
                  sm: '15px',
                  xs: '15px',
                }}
              >
                1. Cutting edge rooftop solar systems
              </Typography>

              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                component={motion.h5}
                sx={{ fontWeight: '600' }}
                fontSize={{
                  md: '20px',
                  sm: '15px',
                  xs: '15px',
                }}
              >
                2. Location & weather aware solar installation
              </Typography>

              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                component={motion.h5}
                sx={{ fontWeight: '600' }}
                fontSize={{
                  md: '20px',
                  sm: '15px',
                  xs: '15px',
                }}
              >
                3. 100% generation guarantee
              </Typography>
            </Stack>
            <Stack
              alignContent={isMobile ? 'center' : 'left'}
              spacing={2}
              marginY={isMobile ? '1rem' : '2rem'}
            >
              {!openForm && (
                <Button
                  variant='contained'
                  onClick={handleGetQuote}
                  size='medium'
                  endIcon={<ArrowCircleRightIcon />}
                  disableElevation
                  sx={{
                    marginBottom: isMobile ? '10px' : '3rem',
                    maxWidth: isMobile ? '100%' : '50%',
                    textTransform: 'none',
                  }}
                >
                  Get solar quote
                </Button>
              )}
            </Stack>
            <Typography
              fontWeight={'600'}
              mb={'1rem'}
              color={'text.secondary'}
              variant={isMobile ? 'body2' : 'body1'}
            >
              Transparent rooftop solar prices starting at ₹45,000/kW with
              expert solar panel installation and guidance through solar subsidy
              2026 eligibility
            </Typography>

            <Typography
              custom={0.5}
              variant='h5'
              variants={fadeAnimateVariants}
              initial='initial'
              whileInView='animate'
              viewport={{
                once: true,
              }}
              component={motion.h5}
              sx={{ fontWeight: '600' }}
              fontSize={{
                md: '15px',
                sm: '15px',
                xs: '15px',
              }}
            >
              Questions?{' '}
              <Link
                href='https://forms.gle/FYBfYapmfg77pZkz9'
                sx={{
                  textDecoration: 'underline',
                  color: 'black',
                }}
              >
                Contact us
              </Link>
            </Typography>
            <Stack
              direction={isMobile ? 'column' : 'row'}
              spacing={1}
              pt={'10px'}
            >
              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                component={motion.h5}
                sx={{
                  fontWeight: '600',
                  textDecoration: 'underline',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
                fontSize={{
                  md: '15px',
                  sm: '15px',
                  xs: '15px',
                }}
                onClick={() => {
                  navigate('/roi');
                }}
              >
                Check rooftop solar RoI here
              </Typography>
              <Typography
                display={isMobile ? 'none' : 'block'}
                variant='h6'
                component={motion.h5}
                sx={{
                  fontWeight: '600',
                }}
              >
                |
              </Typography>
              <Typography
                custom={0.5}
                variant='h5'
                variants={fadeAnimateVariants}
                initial='initial'
                whileInView='animate'
                viewport={{
                  once: true,
                }}
                component={motion.h5}
                sx={{
                  fontWeight: '600',
                  textDecoration: 'underline',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
                fontSize={{
                  md: '15px',
                  sm: '15px',
                  xs: '15px',
                }}
                onClick={() => {
                  window.location.href =
                    'https://www.vaysolar.com/docs/blog/why-going-solar-now-makes-financial-sense/';
                }}
              >
                Why adopt solar now?
              </Typography>
            </Stack>
            {/* <Box
              sx={{
                border: '1px solid #e0e0e0',
                borderRadius: '16px',
                padding: '24px',
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                width: { xs: '100%', sm: '456px' },
                margin: '20px 0',
              }}
            >
              <Typography variant='h5' fontWeight={'bold'}>
                Top <span style={{ color: 'green' }}>rated & best</span> <br />
                solar professionals!
              </Typography>
              <Stack spacing={3} sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                  <Place sx={{ color: 'green', mr: 1, my: 0.5 }} />
                  <TextField
                    id='pin-code'
                    label='Pin code'
                    variant='standard'
                    value={pincode}
                    error={!!pincodeError}
                    helperText={pincodeError}
                    inputProps={{
                      maxLength: 6,
                      pattern: '[0-9]*',
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      if (value.length <= 6) {
                        setPincode(value);
                        setErrors((prev) => ({ ...prev, pincode: '' }));
                      }
                    }}
                    sx={{ width: '100%' }}
                  />
                </Box>
                {isPincodeValid && (
                  <motion.div
                    variants={slideAnimateVariants}
                    initial='initial'
                    whileInView='animate'
                    style={{ width: '100%' }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                      <SolarPower sx={{ color: 'green', mr: 1, my: 0.5 }} />
                      <TextField
                        id='plant-size'
                        label='Plant size (kW)'
                        variant='standard'
                        value={plantSize}
                        error={!!errors.plantSize}
                        helperText={errors.plantSize}
                        onChange={(e) => {
                          setPlantSize(e.target.value);
                          setErrors((prev) => ({ ...prev, plantSize: '' }));
                        }}
                        sx={{ width: '100%' }}
                      />
                    </Box>
                  </motion.div>
                )}

                <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
                  <Button
                    variant='contained'
                    startIcon={<LocalOfferIcon />}
                    onClick={handleSubmit}
                  >
                    See Local Offers
                  </Button>
                  <Button
                    variant='outlined'
                    startIcon={<HelpIcon />}
                    onClick={() => navigate('/start')}
                    // onClick={() => getOffer(plantSize, pincode)}
                  >
                    Help me choose
                  </Button>
                </Stack>
              </Stack>
            </Box> */}
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default TopSec;
